var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.083 10.4998L8.49629 7.91316L5.90962 10.4998C5.64962 10.7598 5.22962 10.7598 4.96962 10.4998C4.70962 10.2398 4.70962 9.81982 4.96962 9.55982L8.02962 6.49982C8.28962 6.23982 8.70962 6.23982 8.96962 6.49982L12.0296 9.55982C12.1545 9.68438 12.2246 9.85348 12.2246 10.0298C12.2246 10.2062 12.1545 10.3753 12.0296 10.4998C11.7696 10.7532 11.343 10.7598 11.083 10.4998Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.1c3ee8e1c574b00e81ecda363ac2ddab.svg";
export { ForwardRef as ReactComponent };